import { render, staticRenderFns } from "./PreviewIdProof.vue?vue&type=template&id=78554ba8&scoped=true&"
import script from "./PreviewIdProof.vue?vue&type=script&lang=js&"
export * from "./PreviewIdProof.vue?vue&type=script&lang=js&"
import style0 from "./PreviewIdProof.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PreviewIdProof.vue?vue&type=style&index=1&id=78554ba8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78554ba8",
  null
  
)

export default component.exports